import React from 'react'
import { Box, Image, SxProps, SxStyleProp } from 'rebass'
import { IModuleBackgroundColorProps } from '../ModuleSection/ModuleSection'
import { ICMSTextV2Props, TextV2 as Text } from '../Text/TextV2'
import { containerStyles, getBackgroundColor } from './PosterCard.styles'

export interface IPosterCardProps {
  backgroundColor: IModuleBackgroundColorProps
  title: ICMSTextV2Props
  subtitle: ICMSTextV2Props
  imageSrc: string
  imageAlt: string
  listTitle: ICMSTextV2Props
  listItems: IListItemsProps
  footnote: ICMSTextV2Props
  imageSx?: SxStyleProp
  sx?: SxProps | SxStyleProp
}

export interface IListItemsProps {
  items: ICMSTextV2Props[]
  sx?: SxStyleProp
}

export const ListItems = ({ items, sx = {} }: IListItemsProps) => {
  return (
    <Box sx={sx}>
      {items.map((item, index) => (
        <Box key={`list-item-${index}`} sx={{ display: 'flex' }}>
          <Image src="/static/v2/pricing-page/checkmark-gold.svg" sx={{ marginRight: '15px', position: 'relative' }} />
          <Text
            tag={item.tag}
            textFontColor={item.textFontColor}
            textFontStyle={item.textFontStyle}
            mobileText={item.mobileText}
            sx={{
              ...item.sx,
            }}
          >
            {item.text}
          </Text>
        </Box>
      ))}
    </Box>
  )
}

export const PosterCard = ({
  backgroundColor,
  title,
  subtitle,
  imageSrc,
  imageAlt,
  imageSx = {},
  listTitle,
  listItems,
  footnote,
  sx = {},
}: IPosterCardProps) => {
  return (
    <Box sx={{ ...containerStyles, ...(sx as Record<string, string>), ...getBackgroundColor(backgroundColor) }}>
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <Image src={imageSrc} alt={imageAlt} sx={imageSx} />
      </Box>
      <Text
        tag={title.tag}
        textFontColor={title.textFontColor}
        textFontStyle={title.textFontStyle}
        mobileText={title.mobileText}
        sx={{
          paddingBottom: '10px',
          ...title.sx,
        }}
      >
        {title.text}
      </Text>
      <Text
        tag={subtitle.tag}
        textFontColor={subtitle.textFontColor}
        textFontStyle={subtitle.textFontStyle}
        mobileText={subtitle.mobileText}
        sx={{
          paddingBottom: '10px',
          marginBottom: '32px',
          ...subtitle.sx,
        }}
      >
        {subtitle.text}
      </Text>
      <Text
        tag={listTitle.tag}
        textFontColor={listTitle.textFontColor}
        textFontStyle={listTitle.textFontStyle}
        mobileText={listTitle.mobileText}
        sx={{
          marginBottom: '16px',
          ...listTitle.sx,
        }}
      >
        {listTitle.text}
      </Text>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <ListItems items={listItems.items} sx={listItems.sx} />
        <Text
          tag={footnote.tag}
          textFontColor={footnote.textFontColor}
          textFontStyle={footnote.textFontStyle}
          mobileText={footnote.mobileText}
          sx={{
            paddingBottom: '10px',
            marginTop: '32px',
            ...footnote.sx,
          }}
        >
          {footnote.text}
        </Text>
      </Box>
    </Box>
  )
}
